import { render } from "./ConfigForm.vue?vue&type=template&id=e5eff61c"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"

import "./ConfigForm.vue?vue&type=style&index=0&id=e5eff61c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__